var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 18C55.2548 18 66 28.7452 66 42C66 55.2548 55.2548 66 42 66C28.7452 66 18 55.2548 18 42C18 28.7452 28.7452 18 42 18ZM42 22C30.9543 22 22 30.9543 22 42C22 53.0457 30.9543 62 42 62C53.0457 62 62 53.0457 62 42C62 30.9543 53.0457 22 42 22ZM41.407 49.3953C42.6546 49.3953 43.6403 50.4041 43.6403 51.6895C43.6403 52.9749 42.6546 54 41.407 54C40.1595 54 39.1584 52.9749 39.1584 51.6895C39.1584 50.4041 40.1595 49.3953 41.407 49.3953ZM41.9615 30C46.1353 30 49 32.5058 49 36.1831C49 38.6725 47.8295 40.381 45.7349 41.699C43.7173 42.9356 43.2244 43.7166 43.1012 45.1973C42.9472 46.2712 42.4235 46.9383 41.3762 46.9383C40.2893 46.9383 39.6539 46.1807 39.5687 45.1215L39.5589 44.8719V44.5627C39.5589 42.6796 40.3907 41.3918 42.0668 40.2495L42.4389 40.0068C44.3487 38.7864 44.9956 37.8915 44.9956 36.3295C44.9956 34.5559 43.6865 33.3193 41.7921 33.3193C40.0825 33.3193 38.9428 34.2142 38.4499 35.8576C38.1111 36.8664 37.5413 37.2732 36.6942 37.2732C35.6315 37.2732 35 36.5898 35 35.4997C35 34.8 35.1386 34.198 35.4312 33.5797C36.3861 31.3668 38.7888 30 41.9615 30Z",
    fill: "#111015"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.e3f401ed5a116a8a16a7311d151680a8.svg";
export { ForwardRef as ReactComponent };